import { APP_BASE_HREF } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ABTestModule } from '@shared/abtest';

import { RedirectToPhpGuard } from '../app/redirect-to-php-guard.service';
import { environment } from '../environments/environment';

import { CompatABTestComponent } from './compat-abtest.component';

@Component({
  template: `<!-- this is empty -->`,
})
export class EmptyComponent {}

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '**',
        component: EmptyComponent,
        canActivate: [RedirectToPhpGuard],
      },
    ]),
    ABTestModule.initialize(environment.abtestConfig),
  ],
  declarations: [EmptyComponent, CompatABTestComponent],
  providers: [RedirectToPhpGuard, { provide: APP_BASE_HREF, useValue: '/' }],
  entryComponents: [CompatABTestComponent],
})
export class CompatABTestModule {}



// WEBPACK FOOTER //
// ./src/compat/compat-abtest.module.ts